
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","d":"M15.5 23.25v-3.739l1.007.168A3 3 0 0020 16.72v-2.458l.935-.234a1.5 1.5 0 00.884-2.287L20 9.011v-.75c0-4.426-4.479-7.96-9.818-7.46A8.994 8.994 0 006.5 17.546v5.7"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","d":"M8.572 8.25a3 3 0 114 2.829 1.5 1.5 0 00-1 1.415v.256"}}),_c('path',{attrs:{"stroke":"currentColor","stroke-width":"1.5","d":"M11.572 16.5a.375.375 0 010-.75m0 .75a.375.375 0 000-.75"}})])
          )
        }
      }
    